import {createContext} from 'react';

import {WalkthroughId} from './types';

export interface WalkthroughContextValue {
  /**
   * The walkthrough id requested for an immediate restart.
   * Pages render `<Walkthrough id={...} />` and forcibly restart when this matches.
   */
  pendingRestartId: WalkthroughId | null;
  /** Request a walkthrough to restart on the next page that hosts it. */
  requestRestart: (id: WalkthroughId) => void;
  /** Called by the hosting `<Walkthrough />` once it has consumed the request. */
  consumeRestart: (id: WalkthroughId) => void;
}

const defaultValue: WalkthroughContextValue = {
  pendingRestartId: null,
  requestRestart: () => undefined,
  consumeRestart: () => undefined,
};

export const WalkthroughContext = createContext<WalkthroughContextValue>(defaultValue);
WalkthroughContext.displayName = 'WalkthroughContext';
